module.exports = __webpack_public_path__ + "img/qq_group_bg.fc773764.png";